module.exports = __webpack_public_path__ + "static/media/two_point_five.8191a960.png";